function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var MultipleSelect = /*#__PURE__*/function () {
  function MultipleSelect(autocomplete) {
    _classCallCheck(this, MultipleSelect);

    this.selectedValues = new Set();
    this.defaultSelectedValues = [];

    this.findByValue = function (value) {
      return function (target) {
        return target.getAttribute('value') === value;
      };
    };

    this.autocomplete = autocomplete;
  }

  _createClass(MultipleSelect, [{
    key: "connected",
    value: function connected() {
      var _this = this;

      this.defaultSelectedValues = this.tags.reduce(function (array, tag) {
        var hiddenField = tag.querySelector('[data-behavior="hidden-field"]');
        var value = hiddenField.value;

        _this.selectedValues.add(value);

        array.push({
          value: value,
          text: hiddenField.getAttribute('data-text') || ''
        });
        return array;
      }, []);
    }
  }, {
    key: "start",
    value: function start() {
      this.selectOrDeselectOptions();

      if (this.firstActivableOption) {
        this.autocomplete.combobox.activate(this.firstActivableOption, {
          scroll: true
        });
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.autocomplete.input.value = '';
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this2 = this;

      this.clear();
      this.defaultSelectedValues.forEach(function (_ref) {
        var value = _ref.value,
            text = _ref.text;
        return _this2.setValue(value, text);
      });
    }
  }, {
    key: "select",
    value: function select(option) {
      var value = option.getAttribute('value');
      var text = option.dataset.text;
      if (!value) return;

      if (this.selectedValues.has(value)) {
        this.removeValue(value);
      } else {
        this.setValue(value, text || '');
      }
    }
  }, {
    key: "setValue",
    value: function setValue(value, text) {
      if (this.selectedValues.has(value)) return;
      this.selectedValues.add(value);
      this.insertTag(value, text.trim());
      this.toggleSelectedClass();
      this.required = this.autocomplete.required; // Only select the option if autocomplete is open, otherwise leave it as it is because aria-selected will be
      // "false" when the autocomplete is hidden.

      if (!this.autocomplete.open) return;
      var option = this.autocomplete.options.find(this.findByValue(value));

      if (option) {
        this.autocomplete.combobox.select(option);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this3 = this;

      this.selectedValues.forEach(function (value) {
        return _this3.removeValue(value);
      });
    }
  }, {
    key: "removeValue",
    value: function removeValue(value) {
      if (!this.selectedValues.has(value)) return;
      this.selectedValues.delete(value);
      this.removeTag(value);
      this.toggleSelectedClass();
      this.required = this.autocomplete.required;
      var option = this.autocomplete.options.find(this.findByValue(value));

      if (option) {
        this.autocomplete.combobox.deselect(option);
      }
    }
  }, {
    key: "required",
    set: function set(value) {
      if (!value || value && this.selectedValues.size > 0) {
        this.autocomplete.input.required = false;
        return;
      }

      this.autocomplete.input.required = true;
    }
  }, {
    key: "selectOrDeselectOptions",
    value: function selectOrDeselectOptions() {
      var _iterator = _createForOfIteratorHelper(this.autocomplete.options),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var option = _step.value;
          var value = option.getAttribute('value');

          if (value && this.selectedValues.has(value)) {
            this.autocomplete.combobox.select(option);
          } else {
            this.autocomplete.combobox.deselect(option);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "insertTag",
    value: function insertTag(value, text) {
      var templateClone = this.template.content.cloneNode(true);
      var tagField = templateClone.querySelector('[data-behavior="tag"]');
      var tagText = templateClone.querySelector('[data-behavior="text"]');
      var tagHiddenField = templateClone.querySelector('[data-behavior="hidden-field"]');
      tagField.setAttribute('value', value);
      tagText.innerText = text;
      tagHiddenField.value = value;
      tagHiddenField.setAttribute('data-text', text);
      this.autocomplete.control.insertBefore(templateClone, this.template);
    }
  }, {
    key: "removeTag",
    value: function removeTag(value) {
      var tag = this.tags.find(this.findByValue(value));
      tag === null || tag === void 0 ? void 0 : tag.remove();
    }
  }, {
    key: "toggleSelectedClass",
    value: function toggleSelectedClass() {
      this.autocomplete.toggleSelectedClass(!!this.selectedValues.size);
    }
  }, {
    key: "firstActivableOption",
    get: function get() {
      var _this4 = this;

      var selectedOption = this.autocomplete.options.find(function (o) {
        return _this4.selectedValues.has(o.getAttribute('value'));
      });
      return selectedOption || this.autocomplete.visibleOptions[0];
    }
  }, {
    key: "tags",
    get: function get() {
      return this.autocomplete.tags;
    }
  }, {
    key: "template",
    get: function get() {
      return this.autocomplete.querySelector('[data-behavior="tag-template"]');
    }
  }]);

  return MultipleSelect;
}();

export { MultipleSelect as default };